<template>
  <div class="dashboard">
    <p class="dashboard__title">
      {{ t('profile.dashboard.title1') }} <span>{{ userFirstName }} {{ userLastName }}</span> ({{ t('profile.dashboard.title2') }} <span>{{ userFirstName }} {{ userLastName }}</span>? <span class="dashboard__link" @click="logout">{{ t('profile.nav.logOut') }}</span>)
    </p>
    <p class="dashboard__text"></p>
    <i18n-t tag="p" class="dashboard__text" scope="global" keypath="profile.dashboard.text">
      <template #orders>
        <span>{{ t('profile.dashboard.recentOrders') }}</span>
      </template>
      <template #accDetails>
        <span>{{ t('profile.dashboard.accDetails') }}</span>
      </template>
    </i18n-t>
    <div class="dashboard__block">
      <div @click="redirect('profile-orders')" class="dashboard__item">
        <svg width="41" height="51" viewBox="0 0 41 51" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 0L1.5 49.5H40V12.5M0.5 1H28.5M40 12.5H28.5V1M40 12.5L28.5 1" stroke="currentColor" stroke-width="2"/>
          <path d="M19 19H32" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M9 18L10.2895 19.9343C10.6504 20.4756 11.4239 20.5337 11.8615 20.0523L16 15.4996" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M9.19995 27.5L10.4895 29.4343C10.8503 29.9756 11.6239 30.0337 12.0615 29.5523L16.2 24.9996" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M9.3999 37L10.6894 38.9343C11.0503 39.4756 11.8238 39.5337 12.2614 39.0523L16.3999 34.4996" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M19 28H32" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M19 37H32" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        <p>{{ t('profile.nav.orders') }}</p>
      </div>
      <div @click="redirect('profile-details')" class="dashboard__item">
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M24.9858 7.56091C24.9858 7.56091 22.7405 7.5783 21.4242 8.06961C19.8227 8.66737 18.8086 9.19021 17.8624 10.6139C17.1668 11.6606 17.1002 12.4363 16.8448 13.6668C16.4006 15.8069 16.8448 17.2284 16.8449 19.2636C16.845 19.98 16.0939 19.4815 15.8273 20.2813C15.3185 21.8077 15.3534 21.9815 15.8273 24.3518C15.9926 25.1785 16.3361 25.3694 16.8449 25.8782C17.5614 26.5947 17.9183 28.0249 18.3714 28.9311C18.8802 29.9488 19.389 30.4576 19.8978 31.4752C20.5198 32.7191 20.4312 33.9702 19.8981 35.0364C18.8802 37.0723 16.5953 37.7053 13.7923 39.1072C10.7395 40.6342 7.68659 42.1603 7.68659 42.1603" stroke="currentColor" stroke-width="2"/>
          <path d="M24.7315 7.59411C24.7315 7.59411 26.9768 7.6115 28.2931 8.10281C29.8945 8.70057 30.9087 9.22342 31.8549 10.6471C32.5505 11.6938 32.6171 12.4695 32.8725 13.7C33.3167 15.8401 32.8725 17.2616 32.8724 19.2968C32.8723 20.0132 33.6234 19.5147 33.89 20.3145C34.3988 21.8409 34.3639 22.0147 33.89 24.385C33.7247 25.2117 33.3812 25.4026 32.8723 25.9114C32.1559 26.6279 31.799 28.0581 31.3459 28.9643C30.8371 29.982 30.3283 30.4908 29.8195 31.5084C29.1975 32.7523 29.2861 34.0034 29.8192 35.0696C30.8371 37.1055 33.122 37.7385 35.925 39.1405C38.9778 40.6674 42.0307 42.1935 42.0307 42.1935" stroke="currentColor" stroke-width="2"/>
          <circle cx="25" cy="25" r="24" stroke="currentColor" stroke-width="2"/>
        </svg>
        <p>{{ t('profile.nav.accountDetails') }}</p>
      </div>
      <div @click="redirect('profile-wishlist')" class="dashboard__item">
        <svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.9209 11.1504H19.9219C22.2571 11.1445 24.5601 11.682 26.6396 12.7197C28.7193 13.7575 30.515 15.2657 31.8789 17.1172L32 17.2812L32.1211 17.1172C34.7932 13.4884 39.1537 11.1504 44.0791 11.1504C47.9976 11.1504 51.7546 12.6719 54.5244 15.3789C57.2941 18.0859 58.8495 21.7563 58.8496 25.583C58.8496 29.5672 57.1918 33.1406 54.5186 35.7812L32 57.79L9.48145 35.7812C6.80822 33.1406 5.15039 29.5672 5.15039 25.583C5.15049 21.7563 6.70593 18.0859 9.47559 15.3789C12.2454 12.6719 16.0024 11.1504 19.9209 11.1504ZM44.0791 13.6279C41.9237 13.6247 39.8054 14.1792 37.9404 15.2363C36.0782 16.2919 34.5349 17.8109 33.4668 19.6387L32 21.8398L30.5332 19.6387C28.4307 16.0421 24.4621 13.6279 19.9209 13.6279C16.6789 13.628 13.5689 14.8865 11.2754 17.1279C8.98174 19.3697 7.69248 22.4112 7.69238 25.583L7.7041 26.1699C7.76695 27.5379 8.0731 28.8862 8.60938 30.1543C9.14576 31.4226 9.90312 32.5887 10.8467 33.6006L11.2617 34.0244L31.8955 54.1631L32 54.2656L32.1045 54.1631L52.7383 34.0244L52.7393 34.0234C54.8683 31.9145 56.3076 28.8765 56.3076 25.583C56.3075 22.4112 55.0183 19.3697 52.7246 17.1279C50.5745 15.0266 47.7068 13.7892 44.6855 13.6426L44.0791 13.6279Z"
              fill="currentColor" stroke="white" stroke-width="0.3"/>
        </svg>
        <p>{{ t('profile.nav.wishlist') }}</p>
      </div>
      <div @click="redirect('profile-cart')" class="dashboard__item">
        <svg width="77" height="77" viewBox="0 0 77 77" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M54 52L20.02 52.3603C19.558 52.3603 19.096 52.0523 18.788 51.7443C18.48 51.4363 18.48 50.8203 18.634 50.3583L22.5 42.9663L17.5 13H7.5V11H18.5C19.27 11 19.346 11.73 19.5 12.5L24.64 42.9663C24.64 43.2743 24.64 43.4283 24.486 43.7363L21 50.3583L55 50L54 52Z" fill="currentColor"/>
          <path d="M22.7921 44.9995V42.9995H56.5001L60 25.4995L20.5 20.9995V18.8311L60.5 23.4995C61.424 23.4995 62 24.5755 62 25.4995L60 35.4995C60 35.4995 58.77 44.8455 58 44.9995H22.7921ZM55.4401 60.9995C52.0521 60.9995 50 58.828 50 55.44C50 52.052 52.0521 49.9995 55.4401 49.9995C58.8281 49.9995 61 52.1115 61 55.4995C61 58.8875 58.8281 60.9995 55.4401 60.9995ZM55.4401 52.36C53.7461 52.36 52.3601 53.746 52.3601 55.44C52.3601 57.134 53.7461 58.52 55.4401 58.52C57.1341 58.52 58.5201 57.134 58.5201 55.44C58.5201 53.746 57.1341 52.36 55.4401 52.36ZM18.4801 60.9995C15.0921 60.9995 13 58.8875 13 55.4995C13 52.1115 15.0921 49.9995 18.4801 49.9995C21.8681 49.9995 24 52.052 24 55.44C24 58.828 21.8681 60.9995 18.4801 60.9995ZM18.4801 52.36C16.7861 52.36 15.4001 53.746 15.4001 55.44C15.4001 57.134 16.7861 58.52 18.4801 58.52C20.1741 58.52 21.5601 57.134 21.5601 55.44C21.5601 53.746 20.1741 52.36 18.4801 52.36Z" fill="currentColor"/>
        </svg>
        <p>{{ t('profile.nav.cart') }}</p>
      </div>
      <div @click="logout" class="dashboard__item">
        <svg width="50" height="57" viewBox="0 0 50 57" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M40.7673 35.6898L50 25.5517L40.7673 15.4137C40.684 15.2941 40.578 15.1954 40.4567 15.1244C40.3354 15.0534 40.2015 15.0117 40.0642 15.0021C39.9268 14.9926 39.7892 15.0153 39.6606 15.0689C39.532 15.1225 39.4154 15.2056 39.3188 15.3127C39.2222 15.4198 39.1478 15.5483 39.1005 15.6895C39.0533 15.8307 39.0344 15.9814 39.0452 16.1313C39.0559 16.2812 39.096 16.4268 39.1627 16.5583C39.2294 16.6898 39.3212 16.8041 39.4319 16.8934L46.3396 24.5022L27.9607 24.5022C27.7059 24.5022 27.4616 24.6128 27.2814 24.8096C27.1012 25.0065 27 25.2734 27 25.5517C27 25.8301 27.1012 26.097 27.2814 26.2938C27.4616 26.4907 27.7059 26.6012 27.9607 26.6012L46.3396 26.6012L39.4319 34.21C39.2523 34.4077 39.1519 34.6751 39.1528 34.9536C39.1537 35.2321 39.2558 35.4988 39.4367 35.6951C39.6176 35.8913 39.8625 36.001 40.1174 36C40.3724 35.999 40.6165 35.8874 40.7962 35.6898L40.7673 35.6898Z" fill="currentColor"/>
          <path d="M32.9722 19.4998L32.9723 4.00079L3.00006 4.00079M3.00006 4.00079L3.00006 47.501L21.5001 53.5004L21.5 46.5003M3.00006 4.00079L21.5 10.0003L21.5 32.0003L21.5 46.5003M21.5 46.5003L32.9723 46.5L32.9723 31.9997" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <p>{{ t('profile.nav.logOut') }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useRouter} from "vue-router";
import {useAuthStore} from "@/stores/auth.js";
import {useI18n} from "vue-i18n";
import {computed} from "vue";

const {t} = useI18n()
const router = useRouter()
const authStore = useAuthStore()

const userFirstName = computed(() => {
  return authStore?.user?.firstName ? authStore.user.firstName : ''
})
const userLastName = computed(() => {
  return authStore?.user?.lastName ? authStore.user.lastName : ''
})

const logout = async () => {
  authStore.setUser({
    user: null,
    accessToken: null
  })

  localStorage.removeItem('ngs-refresh')
  localStorage.removeItem('ngs-remember')
  localStorage.removeItem('ngs-login')

  await router.push({
    name: 'home',
    params: {
      locale: localStorage.getItem('ngs-user-locale') || 'en-gb'
    }
  })
}

const redirect = (route) => {
  router.push({
    name: route,
    params: {
      locale: localStorage.getItem('ngs-user-locale') || 'en-gb'
    }
  })
}
</script>

<style lang="scss" scoped>
.dashboard {
  display: flex;
  flex-direction: column;
  gap: 15px;

  &__title {
    color: #5A5A5A;
    font-size: 18px;
    font-weight: 400;
    line-height: 28.16px;

    & span {
      font-weight: 700;
    }
  }

  &__link {
    cursor: pointer;
    font-weight: 400 !important;
    transition: 0.2s;

    @include hover {
      color: #FF6162;
    }
  }

  &__text {
    color: #5A5A5A;
    text-align: justify;
    font-size: 18px;
    font-weight: 400;
    line-height: 28.16px;

    & span {
      cursor: pointer;
      transition: 0.2s;

      @include hover {
        color: #FF6162;
      }
    }
  }

  &__block {
    margin-top: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
  }

  &__item {
    cursor: pointer;
    border-radius: 10px;
    background-color: $white;
    border: 1px solid #D5D5D5;
    width: 277px;
    height: 124px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transition: 0.2s;

    @include hover {
      background-color: #F1F1F1;

      & svg {
        color: #FF6162;
      }
    }

    & svg {
      transition: 0.2s;
      color: #B6B5B5;
    }

    & p {
      color: #2F2F2F;
      font-size: 14px;
      font-weight: 700;
      line-height: 25.6px;
    }
  }
}

@media (max-width: 900px) {
  .dashboard {
    &__item {
      width: 200px;
    }
  }
}

@media (max-width: 700px) {
  .dashboard {
    &__item {
      width: 150px;
    }
  }
}

@media (max-width: 575px) {
  .dashboard {
    &__block {
      justify-content: center;
    }
  }
}
</style>